export default (route) => {
  const {
    hash, meno, priezvisko, cislo, email, telefon, channel, verzia,
  } = route.query;

  const data = {
    name: '',
    surname: '',
    number: '',
    email,
    phone: '',
    callcentrumBroker: false,
    channel,
    version: verzia,
  };

  // Get broker data from hash
  if (hash && typeof hash === 'string') {
    const decodedHash = atob(hash);
    const urlParams = new URLSearchParams(decodedHash);

    const getParam = (paramName) => urlParams?.get(paramName)?.split('#')[0];

    data.name = getParam('meno');
    data.surname = getParam('priezvisko');
    data.number = getParam('cislo');
    data.email = getParam('email');
    data.phone = getParam('telefon');
    data.version = verzia || getParam('verzia');
    data.callcentrumBroker = data.version === 'callcentrum';
  }

  // Get broker data from queries
  if (meno && priezvisko && cislo) {
    data.name = meno;
    data.surname = priezvisko;
    data.phone = telefon;
  }

  if (cislo && !data.number) {
    data.number = cislo;
  }

  return data;
};
